import { LockOutlined, MailOutlined } from '@ant-design/icons';
import { colors } from '@navicosa/ui-tokens';
import { Alert, Button, Card, Form, Input, Typography } from 'antd';
import { useState } from 'react';
import { errorText } from '../api/client';
import { useAuth } from '../auth/AuthContext';

export function LoginPage() {
  const { login } = useAuth();
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'grid',
        placeItems: 'center',
        background: colors.background,
        padding: 16,
      }}
    >
      <Card style={{ width: '100%', maxWidth: 400 }}>
        <Typography.Title level={3} style={{ color: colors.brand600, marginBottom: 4 }}>
          NAVICOSA RENTAL
        </Typography.Title>
        <Typography.Paragraph type="secondary">Đăng nhập trang quản trị</Typography.Paragraph>
        {error && <Alert type="error" showIcon message={error} style={{ marginBottom: 16 }} />}
        <Form
          layout="vertical"
          requiredMark={false}
          onFinish={async (v: { email: string; password: string }) => {
            setBusy(true);
            setError(null);
            try {
              await login(v.email.trim(), v.password);
            } catch (e) {
              setError(errorText(e));
            } finally {
              setBusy(false);
            }
          }}
        >
          <Form.Item
            name="email"
            label="Email"
            rules={[{ required: true, type: 'email', message: 'Nhập email hợp lệ' }]}
          >
            <Input prefix={<MailOutlined />} autoComplete="username" size="large" />
          </Form.Item>
          <Form.Item
            name="password"
            label="Mật khẩu"
            rules={[{ required: true, message: 'Nhập mật khẩu' }]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              autoComplete="current-password"
              size="large"
            />
          </Form.Item>
          <Button type="primary" htmlType="submit" block size="large" loading={busy}>
            Đăng nhập
          </Button>
        </Form>
      </Card>
    </div>
  );
}
